"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _util = require("@bento-core/util");
var _PropertyItem = _interopRequireDefault(require("./PropertyItem"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CARD_PROPERTIES = [{
  label: 'Program ID',
  dataField: 'program_id',
  link: '/program/{program_id}'
}, {
  label: 'Diagnosis',
  dataField: 'diagnosis'
}, {
  label: 'Age',
  dataField: 'age'
}];
var CaseCard = function CaseCard(_ref) {
  var data = _ref.data,
    classes = _ref.classes,
    index = _ref.index;
  var propertiesWithLinks = (0, _util.prepareLinks)(CARD_PROPERTIES, data);
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    className: classes.card,
    id: "global_search_card_".concat(index)
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 1,
    className: classes.indexContainer
  }, index + 1), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 11,
    className: classes.propertyContainer
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.detailContainerHeader
  }, "CASE"), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/case/".concat(data.subject_id),
    className: classes.cardTitle
  }, data.subject_id))), propertiesWithLinks.map(function (prop, idx) {
    return /*#__PURE__*/_react.default.createElement(_PropertyItem.default, {
      index: idx,
      label: prop.label,
      value: data[prop.dataField],
      link: prop.link
    });
  })));
};
var styles = function styles(theme) {
  return {
    indexContainer: {
      padding: '18px 0px 18px 18px',
      color: '#747474',
      fontFamily: 'Inter',
      fontSize: '13px'
    },
    propertyContainer: {
      padding: '16px 16px 16px 0px',
      borderBottom: '2px solid #E7EEF5'
    },
    cardTitle: {
      color: theme.palette.text.link,
      textDecoration: 'none',
      fontSize: '16px',
      fontFamily: 'Nunito',
      paddingLeft: '9px',
      verticalAlign: 'middle'
    },
    detailContainerHeader: {
      textTransform: 'uppercase',
      padding: '2px 8px',
      backgroundColor: '#C0E9D7',
      color: '#000000',
      fontFamily: 'Nunito',
      fontSize: '12px',
      fontWeight: '400',
      letterSpacing: '0.9px',
      verticalAlign: 'middle',
      borderRadius: '4px'
    }
  };
};
var _default = (0, _core.withStyles)(styles, {
  withTheme: true
})(CaseCard);
exports.default = _default;